import { cn } from "@/lib/cn";
import { cva, type VariantProps } from "class-variance-authority";
import { forwardRef, type HTMLAttributes } from "react";

/** Classes of `DisclosureSummary`: a quiet bold toggle line that darkens and underlines on hover, without the native marker. */
export const disclosureSummaryVariants = cva(
  "w-fit cursor-pointer list-none rounded-control px-2 py-1 text-sm font-bold underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 [&::-webkit-details-marker]:hidden",
  {
    variants: {
      tone: {
        neutral: "text-card-text/75 hover:text-card-text focus-visible:ring-primary",
        game: "text-game-muted hover:text-game-ink focus-visible:ring-game-gold",
      },
    },
    defaultVariants: { tone: "neutral" },
  },
);

/** Props of `DisclosureSummary`; `className` is for layout only. */
export type DisclosureSummaryProps = VariantProps<typeof disclosureSummaryVariants> & Omit<HTMLAttributes<HTMLElement>, "color">;

/** The `<summary>` of a native `<details>` ("Ver código"): muted label that darkens on hover; `tone="game"` for the prize games. */
export const DisclosureSummary = forwardRef<HTMLElement, DisclosureSummaryProps>(function DisclosureSummary(
  { tone, className, ...rest },
  ref,
) {
  return <summary {...rest} ref={ref} className={cn(disclosureSummaryVariants({ tone }), className)} />;
});
